import {ShieldAlert} from "lucide-react";

import {Button} from "@/components/ui/button";
import {Dialog, DialogContent} from "@/components/ui/dialog";
import {
  ComplianceGateActionError,
  ComplianceGateDialogHeader,
  complianceGateDialogContentClassName,
} from "@/src/modules/core/components/compliance-gate-dialog";

import type {SecurityLicenseBlockDisplay} from "../../lib/shift-start-license-errors";

type ShiftLicenseBlockDialogProps = {
  open: boolean;
  display: SecurityLicenseBlockDisplay | null;
  onOpenChange: (open: boolean) => void;
};

export function ShiftLicenseBlockDialog({
  open,
  display,
  onOpenChange,
}: ShiftLicenseBlockDialogProps) {
  if (!display) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={complianceGateDialogContentClassName}>
        <div className="flex flex-col gap-4">
          <ComplianceGateDialogHeader
            icon={ShieldAlert}
            title="Cannot start shift"
            description="Your security license status prevents starting this shift."
          />

          {display.blocked_reasons.length > 0 ? (
            <ul className="flex flex-col gap-2">
              {display.blocked_reasons.map((reason) => (
                <li
                  key={`${reason.license_type}-${reason.status}`}
                  className="flex flex-col gap-0.5 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm"
                >
                  <span className="font-medium">{reason.license_type_label}</span>
                  <span className="text-muted-foreground">{reason.status_label}</span>
                </li>
              ))}
            </ul>
          ) : null}

          {display.restriction?.reason ? (
            <p className="text-sm text-muted-foreground">
              <span className="font-medium text-foreground">Restriction: </span>
              {display.restriction.reason}
            </p>
          ) : null}

          <ComplianceGateActionError message={display.title} />

          <Button type="button" className="w-full" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
